import React, { Component } from 'react';
import { connect } from 'react-redux';

import styles from './_styles/AttributeSelect.module.scss';

const allActionCreators = Object.assign({});

export class AttributeSelect extends Component {

	formatOptions() {
		const attrs = this.props.attributeOptions || [];
		return attrs.map(attr => {
			return {
				display: attr.name,
				value: attr.data_key,
			}
		});
	}

	handleChange(evt) {
		// Returns (typeKey, attrValue)
		this.props.onChange(this.props.attributeType?.key, evt.target.value);
	}
	
	render() {
		return <div className={styles.AttributeSelect}>
			<div className={styles.attrWrapper}>
				<div className={`${styles.label} EllipsisElement`}>{this.props.attributeType?.name || ''}</div>
				<div className={styles.dropdownWrapper}>
					<select
						value={this.props.value}
						onChange={this.handleChange.bind(this)}>
						<option value=''>Select an attribute</option>
						{this.formatOptions().map((opt, i) => {
							return <option key={i} value={opt.value}>{opt.display}</option>
						})}
					</select>
				</div>
			</div>
		</div>;
	}
}

function mapStateToProps(state) {
	return {

	};
}

export default connect(mapStateToProps, allActionCreators)(AttributeSelect);